import CarouselCalendar from "./carouselCalendar";
import DoctorInfos from "./doctorInfos";
import { CalendarWrapper, CalendarCard } from "./StyledComponents";

const MainCalendar = () => (
    <CalendarWrapper>
        <CalendarCard>
            <DoctorInfos />
            <CarouselCalendar />
        </CalendarCard>
    </CalendarWrapper>
);

export default MainCalendar;
